import { all, call, put, takeEvery } from "redux-saga/effects"
import { DckActionTypes } from "dck-redux"
import store from "store"

import * as ItemTypes from "../../items/types"
import apiServerApi from "../apiServerApi"

function* loadBatchesSaga() {

  const state = store.get("sessionData")

  try {
    const result = (yield call(
      apiServerApi.getAllBatches,
      state.access_token,
      0,
      100000000
    )).body

    yield put({
      type: DckActionTypes.ITEMS_SET,
      itemType: ItemTypes.Batch,
      data: result
    })
  }
  catch(error) {
    console.error(error)
    yield put({
      type: DckActionTypes.ITEMS_SET,
      itemType: ItemTypes.Batch,
      data: []
    })
  }
}

function* batchesSaga() {
  yield all([
    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.Batch,
      loadBatchesSaga
    )
  ])
}

export default batchesSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/batches.js